import React from "react";
import { Box, Button, Typography } from "@mui/material";

export default function DomainBrandingUpload({ label, value, file, favicon, disabled, onFile, onRemove }) {
    const [preview, setPreview] = React.useState("");
    React.useEffect(() => {
        if (!file) { setPreview(""); return undefined; }
        const url = URL.createObjectURL(file);
        setPreview(url);
        return () => URL.revokeObjectURL(url);
    }, [file]);
    const src = preview || (value && (/^https?:\/\//i.test(value) ? value : `${process.env.REACT_APP_BACKEND_URL || ""}${value}`));
    return (
        <Box sx={{ border: "1px solid", borderColor: "divider", p: 2, borderRadius: 1 }}>
            <Typography variant="subtitle2">{label}</Typography>
            <Box sx={{ height: 100, my: 1, display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "#eeeeee" }}>
                {src ? <img src={src} alt={label} style={{ maxWidth: "100%", maxHeight: 90, objectFit: "contain" }} /> : <Typography variant="body2">Standardbild</Typography>}
            </Box>
            <Typography variant="caption" display="block">PNG, JPG, WEBP{favicon ? ", ICO" : ""} · maximal 5 MB</Typography>
            <Button component="label" disabled={disabled}>
                Datei auswählen
                <input hidden type="file" accept={favicon ? ".png,.jpg,.jpeg,.webp,.ico" : ".png,.jpg,.jpeg,.webp"}
                    onChange={(event) => { const next = event.target.files?.[0]; event.target.value = ""; if (next) onFile(next); }} />
            </Button>
            {(file || value) && <Button color="error" disabled={disabled} onClick={onRemove}>Entfernen</Button>}
            {file && <Typography variant="caption" display="block">{file.name} – wird beim Speichern hochgeladen</Typography>}
        </Box>
    );
}
